module.exports = __webpack_public_path__ + "gürsu özcan bey.jpg?5fde500c5c0646d5c4cb735eaeaf6a5a";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/gürsu özcan bey.jpg
// module id = 351
// module chunks = 0